import { Directionality } from '@angular/cdk/bidi';
import { CdkStepper } from '@angular/cdk/stepper';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ContentChildren,
  ElementRef,
  Input,
  Optional,
  QueryList,
} from '@angular/core';

import { SutStepComponent } from './step.component';
import { NgFor, NgIf, NgTemplateOutlet } from '@angular/common';
import { SutNavStepHeaderComponent } from './nav-step-header.component';
import { MatDivider } from '@angular/material/divider';

@Component({
  selector: 'sut-stepper', // eslint-disable-line @angular-eslint/component-selector
  templateUrl: './stepper.component.html',
  providers: [{ provide: CdkStepper, useExisting: SutStepperComponent }],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgFor, SutNavStepHeaderComponent, MatDivider, NgIf, NgTemplateOutlet],
})
export class SutStepperComponent extends CdkStepper {
  @Input() public isNav: boolean;
  @Input() public dropShadow = true;

  @ContentChildren(SutStepComponent, { descendants: true })
  override _steps: QueryList<SutStepComponent>;

  constructor(
    @Optional() dir: Directionality,
    changeDetectorRef: ChangeDetectorRef,
    elementRef: ElementRef<HTMLElement>,
  ) {
    super(dir, changeDetectorRef, elementRef);
  }

  isSelected(i: number): boolean {
    return this.selectedIndex === i;
  }
}
